import Complex from './complexClass';
export default function polyExpand(poly1, poly2, numberMode = true) {
    // convert everything to complex
    let complexPoly1, complexPoly2;
    complexPoly1 = [];
    complexPoly2 = [];
    poly1.forEach(e => {
        if (!(e instanceof Complex)) {
            complexPoly1.push(new Complex(e, 0));
        }
        else {
            complexPoly1.push(e);
        }
    });
    poly2.forEach(e => {
        if (!(e instanceof Complex)) {
            complexPoly2.push(new Complex(e, 0));
        }
        else {
            complexPoly2.push(e);
        }
    });
    // create 0 array to splice into
    const complexZero = new Complex(0, 0);
    // expand elements of poly1
    let individualArrays;
    individualArrays = [];
    for (let i = 0; i < poly1.length; i++) {
        let zeroArray;
        zeroArray = Array(poly1.length - 1).fill(complexZero);
        let expand = [];
        complexPoly2.forEach(e => {
            expand.push(e.multiply(complexPoly1[i]));
        });
        zeroArray.splice(i, 0, ...expand);
        individualArrays.push(zeroArray);
    }
    // sum up individual arrays
    let finalArray = [];
    for (let i = 0; i < poly1.length + poly2.length - 1; i++) {
        let complexSum = new Complex(0, 0);
        individualArrays.forEach(arr => {
            complexSum = complexSum.add(arr[i]);
        });
        finalArray.push(complexSum);
    }
    if (numberMode) {
        let numberArray = [];
        finalArray.forEach(e => {
            numberArray.push(e.a);
        });
        return numberArray;
    }
    else {
        return finalArray;
    }
}
